import { Box, Button, Dialog, Typography } from '@mui/material';
import { colors } from '../../styles/color';
import { CompleteLogo } from '../../assets/icons';
import { useAppSelector } from '../../hooks/useAppReducer';
import { ApplicationStateType } from '../../redux/store';
import { useCookies } from 'react-cookie';
import { setProfileState } from '../../redux/features/profile/profileSlice';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setDialogState } from '../../redux/features/dialog/dialogSlice';
const ResetPassword = (props: any) => {
  const navigate = useNavigate();
  const {
    dialog: { resetPassword: resetPassword },
  } = useAppSelector((state: ApplicationStateType) => state.dialog);
  const [token, __, removeAccessTokenToken] = useCookies([
    'accessToken',
    'refreshToken',
    'googleToken',
    'role',
  ]);
  const dispatch = useDispatch();
  
  const onResetClick = () => {
    // Remove cookies
    removeAccessTokenToken('accessToken');
    removeAccessTokenToken('refreshToken');
    removeAccessTokenToken('googleToken');
    removeAccessTokenToken('role');
    
    // Remove from localStorage
    localStorage.removeItem('login');
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('googleToken');
    localStorage.removeItem('role');
    localStorage.removeItem('accessToken_expiry');
    localStorage.removeItem('refreshToken_expiry');
    localStorage.removeItem('googleToken_expiry');
    localStorage.removeItem('role_expiry');
    
    // Remove from sessionStorage
    sessionStorage.removeItem('login');
    sessionStorage.removeItem('accessToken');
    sessionStorage.removeItem('refreshToken');
    sessionStorage.removeItem('googleToken');
    sessionStorage.removeItem('role');
    sessionStorage.removeItem('accessToken_expiry');
    sessionStorage.removeItem('refreshToken_expiry');
    sessionStorage.removeItem('googleToken_expiry');
    sessionStorage.removeItem('role_expiry');
    
    dispatch(setProfileState({}));

    // ✅ Show login dialog after reset
    dispatch(setDialogState({
      loginDialog: true,
      registerDialog: false,
      modal: false,
      otpDialog: { otpDialog: false, fromPageName: '' },
      privacyDialog: false,
      resetPassword: false,
      successReset: false,
      termsDialog: false,
      forgotPassword: false,
      sendInquiry: false,
      addLink: false,
      newPassword: false,
      logout: false,
      influencerLogin: false,
    }));

    // ✅ Navigate based on role
    if (token.role === '2') {
      navigate('/sign-in');
    } else {
      navigate('/');
    }
  };


  return (
    <Box textAlign="center" m={'36px'}>
      <Box
        sx={{
          '& svg': {
            width: '120px',
            height: '120px',
          },
        }}
      >
        <CompleteLogo />
      </Box>
      <Box mt={'30px'}>
        <Typography variant="body1" fontWeight={600}   sx={{
                  fontSize: {
                    xs: "20px",
                    sm: "22px",
                    md: "24px",
                  },
                }}>
          Password reset
        </Typography>
        <Typography variant="body2" color={colors.gray[300]} mt={'12px'} p={'0px 14px'}>
          Your password has been reset successfully
        </Typography>
      </Box>
      <Box width={'100%'} mt={'32px'}>
        <Button
          sx={{ width: '100%', maxWidth: resetPassword ? '438px' : 'auto' }}
          onClick={() => onResetClick()}
        >
          {resetPassword ? 'Back to Login' : 'Ok'}
        </Button>
      </Box>
    </Box>
  );
};

export default ResetPassword;
